/*
 * @Author: lihefei
 * @Date: 2019-07-29 17:08:52
 * @Last Modified by: lihefei
 * @Last Modified time: 2019-07-29 19:16:59
 */

/**
 * 输出接口地址
 * @param {String} env 环境模式
 * @returns  {String} 环境模式对应的baseUrl
 */
export default function() {
    const env = process.env.NODE_ENV; //获取环境
    if (!env) {
        return '';
    }
    const envConfig = {
        development: 'http://localhost:8080', //开发环境
        dubug: 'https://qiguopt.qiguoiot.com/', //调试环境
        // dubug: 'http://localhost:8080', //调试环境
        // production: 'http://localhost:8080', //生产环境
        production: 'https://hschool.qiguoiot.com' //生产环境
    };
    return envConfig[env];
}